import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";

interface StateInterface {
  user: PersonInterface | any;
  isFetching: boolean;
  popup: boolean;
  popupMessage: string;
  email: string;
  password: string;
  confirmPassword: string;
  fields: string[];
  translatedMessage: string;
  agencies: any[];
  users: any[];
}

const initialState: StateInterface = {
  user: {},
  isFetching: false,
  popup: false,
  popupMessage: "",
  email: "",
  password: "",
  confirmPassword: "",
  fields: [],
  translatedMessage: "",
  agencies: [],
  users: []
};

export const confirmReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        user: action.payload?.user,
        users: action.payload?.users,
        agencies: action.payload?.agencies
      };

    case Constants.PAGE_CONFIRM_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_CONFIRM_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_FAILURE:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_CONFIRM_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_CONFIRM_ACCOUNT_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_CONFIRM_CONFIRM_ACCOUNT_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_CONFIRM_ACCOUNT_FAILURE:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_SIGNIN:
      return {
        ...state,
        isFetching: true
      };

    case Constants.PAGE_CONFIRM_SIGNIN_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_SIGNIN_FAILURE:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CONFIRM_UPDATE_PASSWORD:
      return Object.assign({}, state, {
        password: action.payload?.password
      });

    case Constants.PAGE_CONFIRM_UPDATE_CONFIRM_PASSWORD:
      return {
        ...state,
        confirmPassword: action.payload?.confirmPassword
      };

    case Constants.PAGE_CONFIRM_OPEN_POPUP:
      return {
        ...state,
        popup: true,
        popupMessage: action.payload?.message,
        fields: action.payload?.fields,
        translatedMessage: action.payload?.translatedMessage
      };

    case Constants.PAGE_CONFIRM_CLOSE_POPUP:
      return {
        ...state,
        popup: false,
        popupMessage: "",
        fields: [],
        translatedMessage: ""
      };

    case Constants.PAGE_CONFIRM_CLEAR:
      return {
        ...initialState
      };

    case Constants.PAGE_CONFIRM_ERRORS_CLEAR:
      return {
        ...state,
        fields: [],
        translatedMessage: ""
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
